import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const main = {
  namespaced: true,
  state: {
    progress: 0, // counter progress,
    lDrawer: false,
    rDrawer: false,
    hSidebar: false,
  },
  getters: {
    isAnyProgress(state) {
      return state.progress > 0
    },
    lDrawer(state) {
      return state.lDrawer
    },
    rDrawer(state) {
      return state.rDrawer
    },
    hSidebar(state) {
      return state.hSidebar
    },
  },
  mutations: {
    cleanFlag(state) {
      state.is_403 = false
      state.no_instansi = false
      state.no_kegiatan = false
      state.no_grup = false
    },
    pStart(state) {
      state.progress++
    },
    pEnd(state) {
      state.progress--
      if (state.progress < 0) state.progress = 0
    },
    rToggle(state) {
      state.rDrawer = !state.rDrawer
    },
    lToggle(state) {
      state.lDrawer = !state.lDrawer
    },
    setLDrawer(state, val) {
      state.lDrawer = val
    },
    setHsidebar(state, val) {
      state.lDrawer = val
    },
    setRDrawer(state, val) {
      state.rDrawer = val
    },
    lToggleSidebar(state) {
      state.hSidebar = !state.hSidebar
    },
    setTotalInstansi(state, val) {
      state.totalInstansi = val
    },
  },
  actions: {},
}
const store = new Vuex.Store({
  modules: {
    main,
  },
})

export default store
